import { render, staticRenderFns } from "./er404.vue?vue&type=template&id=5478a89c&"
import script from "./er404.vue?vue&type=script&lang=js&"
export * from "./er404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "er404.vue"
export default component.exports